<template>
  <div class="row flex mt-8">
    <div class="small-3 columns">
      <div class="py-3 font-bold text-md">Language #{{ index + 1 }}</div>
      <div class="rounded bg-white">
        <VueSelect
          :value="item.language"
          :options="languages"
          label="name"
          :reduce="lang => lang.name"
          @input="lang => (item.language = lang && lang.name)"
        />
      </div>
    </div>

    <div class="small-4 columns ml-6">
      <div class="py-3 font-bold text-md">Template</div>
      <div>
        <CodeSingleFileUpload
          @codingFileUploadFail="handleTemplateUploadFailure"
          @codingFileUploadSuccess="handleTemplateUploadSuccess($event, item)"
        />
        <div
          v-if="item.template.length > 2"
          class="py-2"
          @click="emitOpenFileEvent(item.template)"
        >
          <strong>File ID:</strong>
          <span class="link"> {{ item.template }} </span>
        </div>
      </div>
    </div>

    <div v-if="is_blockly" class="small-5 flex">
      <div class="edyst-blockly-xml">
        <div class="py-3 font-bold text-md">Blockly Toolbox</div>
        <textarea
          :value="item.blockly_toolbox"
          placeholder="Paste XML here"
          @change="setBlocklyToolbox(index, $event)"
          @input="setBlocklyToolbox(index, $event)"
        />
      </div>
      <div class="edyst-blockly-xml ml-4">
        <div class="py-3 font-bold text-md">Blockly Workspace</div>
        <textarea
          :value="item.blockly_workspace"
          placeholder="Paste XML here"
          @change="setBlocklyWorkspace(index, $event)"
          @input="setBlocklyWorkspace(index, $event)"
        />
      </div>
    </div>

    <div v-else class="small-5 columns ml-6">
      <div class="py-3 font-bold text-md">Placeholder</div>
      <div>
        <codemirror v-model="item.placeholder" :options="cmOptions" />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import "codemirror/lib/codemirror.css"
// eslint-disable-next-line import/no-extraneous-dependencies
import "codemirror/mode/javascript/javascript"

import { codemirror } from "vue-codemirror"

import VueSelect from "vue-select"
import CodeSingleFileUpload from "@/components/shared/fileUpload/CodeSingleFileUpload"

export default {
  components: { codemirror, CodeSingleFileUpload, VueSelect },
  props: ["languages", "item", "index", "is_blockly"],
  data() {
    return {
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "text/javascript",
        theme: "base16-dark",
        lineNumbers: true,
        line: true,
        // more codemirror options, 更多 codemirror 的高级配置...
      },
    }
  },
  methods: {
    setBlocklyToolbox(idx, event) {
      const payload = { idx, event }
      this.$emit("SET_BLOCKLY_TOOLBOX", payload)
    },
    setBlocklyWorkspace(idx, event) {
      const payload = { idx, event }
      this.$emit("SET_BLOCKLY_WORKSPACE", payload)
    },
    emitOpenFileEvent(id) {
      this.$emit("OPEN_MODAL_CONTENT", id)
    },
    handleTemplateUploadFailure() {
      alert("Please upload a valid template")
    },
    handleTemplateUploadSuccess($event, item) {
      if ($event.id === undefined) {
        alert("Please upload a valid template")
        return
      }
      console.log(item, $event.id)
      item.template = $event.id
    },
  },
}
</script>
